<template>
  <!-- 仓库列表专用辅料标识：点击后请求 material/list，再展示辅料详情 -->
  <el-popover placement="left" width="360" trigger="click" popper-class="warehouse-material-mark-popper">
    <div class="warehouse-material-tip">
      <!-- 请求辅料主档时先显示加载状态 -->
      <div v-if="loading" class="warehouse-material-loading">...</div>
      <template v-else>
        <!-- 辅料主档 ID -->
        <div class="warehouse-material-id">
          {{ $t('message.materialId') }}：{{ material.id || materialId }}
        </div>
        <div class="warehouse-material-main">
          <!-- 辅料主图 -->
          <div class="warehouse-material-image">
            <el-image v-if="material.main_image" :src="material.main_image" fit="cover"
              :preview-src-list="[material.main_image]" />
          </div>
          <!-- 辅料名称、类型、状态和库存 -->
          <div class="warehouse-material-content">
            <router-link class="warehouse-material-name" :to="detailLink" target="_blank" @click.native.stop>
              {{ material.name_trans }}
            </router-link>
            <div class="warehouse-material-status" :style="{ color: stockStatusColor }">
              {{ stockStatusText }}
            </div>
            <div class="warehouse-material-type">
              <div class="type">
                {{ material.type_name || (material.type && material.type.name) }}
              </div>
             
            </div>
            <div class="warehouse-material-stock">
              {{ $t('message.actualStockQuantity') }}：{{ material.material_stock_num }}
            </div>
          </div>
        </div>
      </template>
    </div>
    <!-- 当前商品行的辅料标识 -->
    <el-tag slot="reference" class="warehouse-material-mark" size="mini" @click.native="loadMaterial">
      {{ $t('message.auxiliaryMaterials') }}
    </el-tag>
  </el-popover>
</template>

<script>
export default {
  name: 'WarehouseMaterialMarkTip',
  props: {
    // 当前商品绑定的辅料主档 ID
    materialId: {
      default: ''
    },
    // 当前客户 ID，用于限定 material/list 查询范围
    userId: {
      default: ''
    },
    // 当前订单本次出货需要的辅料数量
    requiredQuantity: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      loading: false,
      material: {}
    }
  },
  computed: {
    // 辅料名称点击后打开辅料详情页
    detailLink() {
      return {
        path: '/materialDetail',
        query: {
          id: this.materialId,
          user_id: this.userId
        }
      }
    },
    // 当前辅料库存与本次出货数量比较，避免用全局预计消耗误判当前订单。
    stockStatusText() {
      const stock = Number(this.material.material_stock_num || 0)
      if (stock <= 0) return this.$t('message.noStock')
      if (stock < Number(this.requiredQuantity || 0)) {
        return this.$t('message.stockInsufficient')
      }
      return this.$t('message.stockSufficient')
    },
    // 当前辅料库存状态颜色
    stockStatusColor() {
      const stock = Number(this.material.material_stock_num || 0)
      if (stock <= 0 || stock < Number(this.requiredQuantity || 0)) {
        return '#c8383e'
      }
      return '#15ad3c'
    }
  },
  methods: {
    // 点击辅料标识后请求当前辅料主档
    loadMaterial() {
      this.loading = true
      this.$api.warehouseApi.materialList({
        user_id: this.userId,
        ids:[this.materialId] ,
        page: 1,
        pageSize: 1
      }).then(res => {
        const data = res.data || {}
        const list = data.list || data.data || []
        this.material = list[0] || {}
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.warehouse-material-mark {
  height: 22px;
  padding: 0 6px;
  border: 0;
  border-radius: 2px;
  background-color: #67c23a;
  color: #fff;
  line-height: 22px;
  cursor: pointer;
}

.warehouse-material-tip {
  min-width: 0;
  min-height: 160px;
  padding: 12px 16px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  background: #fff;
  box-sizing: border-box;
}

.warehouse-material-loading {
  min-height: 136px;
  color: #909399;
  line-height: 136px;
  text-align: center;
}

.warehouse-material-id {
  color: #606266;
  font-size: 14px;
  line-height: 19px;
}

.warehouse-material-main {
  display: flex;
  margin-top: 10px;
}

.warehouse-material-image {
  flex: 0 0 96px;
  width: 96px;
  height: 96px;
  margin-right: 12px;
  border-radius: 4px;
  background: #9b9b9b;
  overflow: hidden;
}

.warehouse-material-image .el-image {
  display: block;
  width: 100%;
  height: 100%;
}

.warehouse-material-content {
  flex: 1;
  min-width: 0;
  color: #606266;
  font-size: 12px;
}

.warehouse-material-name {
  display: block;
  margin-bottom: 8px;
  overflow: hidden;
  color: #303133;
  line-height: 18px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.warehouse-material-status {
  margin-bottom: 8px;
  font-weight: bold;
  line-height: 18px;
}

.warehouse-material-type,
.warehouse-material-stock {
  margin-bottom: 6px;
  line-height: 18px;
}
.warehouse-material-type{
  display: flex;
  .type{
    padding: 3px;
    background-color: #67c23a;
    color: #fff;
    border-radius: 4px;
  }
}
</style>
